// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3Sw7M","location":"Header_location__3hSXJ"};